var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bet",
    transform: "translate(-130.000000, -30.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-copy",
    transform: "translate(117.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75,12.375 L13.625,12.375 L13.625,9.25 C13.625,8.905 13.345,8.625 13,8.625 C12.655,8.625 12.375,8.905 12.375,9.25 L12.375,12.375 L9.25,12.375 C8.905,12.375 8.625,12.655 8.625,13 C8.625,13.345 8.905,13.625 9.25,13.625 L12.375,13.625 L12.375,16.75 C12.375,17.095 12.655,17.375 13,17.375 C13.345,17.375 13.625,17.095 13.625,16.75 L13.625,13.625 L16.75,13.625 C17.095,13.625 17.375,13.345 17.375,13 C17.375,12.655 17.095,12.375 16.75,12.375 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.06e8ae19dd3b6af7f9e5d19e7ade8bdf.svg";
export { ForwardRef as ReactComponent };